import { render, staticRenderFns } from "./CourseGrading.vue?vue&type=template&id=98367e56&"
import script from "./CourseGrading.vue?vue&type=script&lang=js&"
export * from "./CourseGrading.vue?vue&type=script&lang=js&"
import style0 from "./CourseGrading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports